<template>
  <div class="app-container">
    <UserInfo v-if="isApiData && apiData.user.uid" :user="apiData.user"></UserInfo>
    <div v-if="isApiData && version === 1">
      <div class="handCard">
        <div data-aos="fade-up" class="background">
          <i18n-t
            class="font40px text"
            data-aos="fade-up"
            data-aos-delay="300"
            keypath="handCard.text"
            tag="div"
            scope="global"
          >
            <template #date>
              <span class="font64px">{{ apiData.firstHand.loginDay }}</span>
            </template>
          </i18n-t>
        </div>
        <div class="decoration">
          <div data-aos="fade-up">
            <img class="king" :src="require('@img/keyVisual/bg_1_1.png')" />
          </div>
          <div data-aos="fade-up" data-aos-delay="500">
            <img class="heart" :src="require('@img/keyVisual/pop_heart.png')" />
          </div>
        </div>
      </div>
      <div data-aos="fade-up" class="report">
        <div data-aos="zoom-out-up" class="background">
          <div class="frame">
            <i18n-t class="font40px loginTime" keypath="report.loginTime" tag="div" scope="global">
              <template #loginDay>
                <div class="section">
                  <CountAnimation
                    :class="`loginDay font80px ${locale}`"
                    :unit="$t('unit.days')"
                    :number="apiData.user.loginDay"
                    :color="`#55FFE4`"
                    tag="span"
                  >
                  </CountAnimation>
                  <img class="countUp" :src="require('@img/keyVisual/bg_2_1.png')" />
                </div>
              </template>
            </i18n-t>
            <span class="tips font27px">{{ $t('report.loginTips') }}</span>
          </div>
        </div>
        <div class="background mt-1px">
          <div class="bgCanvas">
            <i18n-t
              data-aos="fade-up"
              class="enjoyTime font40px"
              keypath="report.enjoyTime"
              tag="div"
              scope="global"
            >
              <template #loginTime>
                <span class="highlight font64px">
                  {{ apiData.user.loginTime }}
                </span>
              </template>
            </i18n-t>
            <img data-aos="fade-up" class="bg_3" :src="require('@img/keyVisual/bg_3.png')" />
            <HandCard
              v-if="apiData.firstHand.handCards"
              data-aos="fade-down"
              class="handCard"
              v-bind="apiData.firstHand"
            ></HandCard>
          </div>
        </div>
      </div>
      <div class="bg_color">
        <!-- hands -->
        <TotalHand :hands-info="apiData.totalHand"></TotalHand>
        <!-- hardTime -->
        <HardTime :data="apiData.maxHand"></HardTime>
        <!-- favoriteGame -->
        <FavoriteGame :data="apiData.preferred"></FavoriteGame>
        <!-- kkwin -->
        <WinHand v-if="apiData.victory.length" :data="apiData.victory"></WinHand>
        <!-- luckyHand -->
        <LuckyHand
          :data="apiData.luckyHand"
          v-if="apiData.luckyHand.winRate || apiData.luckyHand.loseRate"
        ></LuckyHand>
        <!-- achievement -->
        <AchievementInfo :data="apiData.achievement"></AchievementInfo>
        <div class="bg_15_v1 mt-1px"></div>
      </div>
       <!-- <div class="bg_15"></div> -->

      <!-- <div class="trophy" data-aos="fade-up">
        <AchievementProgressBar :data="apiData.trophy">
        </AchievementProgressBar>
      </div> -->

      <div class="futureStory">
        <div data-aos="fade-up" class="textBlock">
          <i18n-t
            data-aos="fade-up"
            data-aos-delay="500"
            class="text font40px"
            keypath="futureStory"
            tag="div"
          >
            <template #year>
              <span class="font46px">2025</span>
            </template>
          </i18n-t>
        </div>
        <img class="bg_16" :src="require('@img/keyVisual/bg_16.png')" />
      </div>
    </div>
    <div v-else>
      <div class="futureStory">
        <div data-aos="fade-up" class="textBlock font40px">
          <div data-aos="fade-up" data-aos-delay="500" class="text font40px">
            {{ $t('version3.text') }}
            <!-- <div class="tips">
              {{ $t("version3.tips") }}
            </div> -->
          </div>
        </div>
        <img class="king" :src="require('@img/keyVisual/bg_1_1.png')" />
        <img class="broken" :src="require('@img/keyVisual/heart_break.png')" />
      </div>
      <div class="continue font40px">
        <i18n-t class="text font40px" keypath="version3.continue" tag="div">
          <template #year>
            <span class="year">2025</span>
          </template>
        </i18n-t>
      </div>
    </div>

    <img
      v-if="isApiData && version !== 3"
      class="bgEnd"
      :src="require('@img/keyVisual/bg_end.png')"
    />
    <SocialShare
      v-if="isApiData && version !== 3"
      :showBtn="isApiData"
      :params="urlParams"
      :loginTime="apiData?.user?.loginTime"
    ></SocialShare>
    <MusicPlay v-if="isApiData && version !== 3"></MusicPlay>
    <CloseBtn></CloseBtn>
  </div>

  <LoadingVue v-if="!state.ready"></LoadingVue>
</template>

<script setup>
import { reactive, ref, onMounted, computed, nextTick } from 'vue';
import { locale, t, messages, i18n } from './locales';
import { loader } from './utils/loader';
import { getReport } from '@/api/official';
import CountAnimation from './components/CountAnimation.vue';
import AOS from 'aos';

const apiData = reactive({});
const version = ref(0);
const isApiData = computed(() => Object.keys(apiData).length > 0);
const state = reactive({
  ready: false
});

const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get('lang') ?? 'en';
const key = urlParams.get('key');
// const uid = urlParams.get("uid")
const noEffect = !!urlParams.get('no_effect');
const loginTime = urlParams.get('login_time_part') ?? '';
const license = process.env.VUE_APP_PROJECT_NAME.toLowerCase();
//TODO: remove force 當上預發布跟線上的時候
// const force = urlParams.get("force")
console.log('-----i18n-----------------');
console.log(i18n);


if (i18n.global.availableLocales.includes(lang)) {
  locale.value = lang;
} else {
  locale.value = 'en';
}
if (key) {
  getReport({ key, loginTime, license }).then(data => {
    version.value = data.version;
    if (data.code === 0) {
      Object.assign(apiData, data);
      console.log(apiData);
      setTimeout(() => {
        AOS.refresh();
      }, 500);
    }
  });
}

loader.load((loader, resources) => {
  // console.log("loader", loader, resources);
  state.ready = true;
});

onMounted(() => {
  let duration = 500;
  if (noEffect) {
    duration = 0;
  }
  nextTick(() => {
    AOS.init({
      offset: 250, // offset (in px) from the original trigger point
      // delay: 200, // values from 0 to 3000, with step 50ms
      duration: duration, // values from 0 to 3000, with step 50ms
      easing: 'ease-in-out', // default easing for AOS animations
      mirror: true,
      once: true,
      anchorPlacement: 'top-center'
    });
  });
});
</script>

<style lang="scss" scoped>
.app-container {
  position: relative;
  margin: 0 auto;
  min-height: 100vh;
  max-width: $containerWidth;
  overflow: hidden;
  // overflow-y: scroll;

  background-color: #252430;
  background-size: 100%;
  background-repeat: no-repeat;

  // -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.handCard {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .background {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('~@img/keyVisual/bg_1.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 750px;
    height: 554px;
    @media (max-width: $containerWidth) {
      width: pxToVw(750px);
      height: pxToVw(554px);
    }
  }
  .text {
    white-space: pre-line;
    margin: 100px 60px 20px 60px;
    text-align: center;
    color: #fff;
    // opacity: 0.8;
    @media (max-width: $containerWidth) {
      margin: pxToVw(100px) pxToVw(60px) pxToVw(20px) pxToVw(60px);
    }
  }
  .decoration {
    display: flex;
    justify-content: space-around;
  }
  .king {
    text-align: center;
    position: relative;
    margin-top: -100px;
    width: 600px;
    @media (max-width: $containerWidth) {
      margin-top: pxToVw(-100px);
      width: pxToVw(600px);
    }
  }
  .heart {
    position: absolute;
    right: 100px;
    bottom: 188px;
    width: 100px;
    animation: heartbeat 2s ease-in-out infinite;

    @media (max-width: $containerWidth) {
      width: pxToVw(100px);
      right: pxToVw(100px);
      bottom: pxToVw(188px);
    }
  }
}

.report {
  position: relative;
  .background {
    display: flex;
    flex-direction: column;
    text-align: center;
    background-image: url('~@img/keyVisual/bg_2.png');
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 100% 100%;
    width: 100%;
    height: 834px;
    @media (max-width: $containerWidth) {
      height: pxToVw(834px);
    }
  }
  .loginTime {
    white-space: pre-line;
    position: relative;
    margin: 55% 8% 0% 8%;
    color: #fff;
  }
  // .frame {
  //   // margin-bottom: 20%;
  // }
  .section {
    position: relative;
  }
  .countUp {
    margin-top: 3%;
    width: 95%;
  }
  .loginDay {
    position: absolute;
    top: 48%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #55ffe4;
    &.hi {
      transform: translate(-50%, -44%);
    }
    &.kr,
    &.ru {
      font-size: 72px;
      @media (max-width: $containerWidth) {
        font-size: pxToVw(72px);
      }
    }
  }
  .tips {
    color: #57576e;
  }

  .background {
    width: 100%;
    height: auto;
  }
  .bgCanvas {
    position: relative;
    background-color: #2a2a3b;
    width: 100%;
    height: 1966px;
    @media (max-width: $containerWidth) {
      height: pxToVw(1966px);
    }
  }
  .bg_3 {
    width: 100%;
  }
  .enjoyTime {
    position: relative;
    text-align: right;
    margin: 250px 60px -35px 60px;
    @media (max-width: $containerWidth) {
      margin: pxToVw(250px) pxToVw(60px) pxToVw(-35px) pxToVw(60px);
    }
  }
  .kkclash_film_1 {
    position: relative;
    margin-top: -40%;
  }
  .film_1 {
    position: absolute;
    bottom: -12%;
  }
}

.bg_color {
  background-color: #2a2a3b;
}

.bg_15_v1 {
  position: relative;
  z-index: 0;
  // background-color: #2a2a3b;
  background-image: url('~@img/keyVisual/bg_15.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  height: 558px;
  margin-top: -250px;
  @media (max-width: $containerWidth) {
    height: pxToVw(558px);
    margin-top: pxToVw(-250px);
  }
}
// .bg_15 {
//   position: relative;
//   width: 100%;
//   height: 100px;
//   background: linear-gradient(to bottom, #2A2A3B , #252430);
//   @media (max-width: $containerWidth) {
//     height: pxToVw(100px);
//   }
// }
.futureStory {
  position: relative;
  .textBlock {
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('~@img/keyVisual/bg_1.png');
    background-size: contain;
    background-repeat: no-repeat;
    white-space: pre-line;
    width: 100%;
    height: 554px;
    @media (max-width: $containerWidth) {
      height: pxToVw(554px);
    }
  }
  .king {
    text-align: center;
    position: relative;
    margin-top: -100px;
    @media (max-width: $containerWidth) {
      margin-top: pxToVw(-100px);
    }
  }
  .broken {
    position: absolute;
    right: 20%;
    bottom: 30%;
    width: 100px;
    animation: heartbeat 2s ease-in-out infinite;

    @media (max-width: $containerWidth) {
      width: pxToVw(100px);
    }
  }
  .text {
    width: 75%;
    margin-top: 11%;
  }
  .bg_16 {
    position: relative;
    width: 100%;
    margin-top: -15%;
  }
  .tips {
    font-size: 25px;
    @media (max-width: $containerWidth) {
      font-size: pxToVw(25px);
    }
  }
}

.continue {
  display: flex;
  background-image: url('~@img/keyVisual/bg_end_v3.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  color: #fff;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 826px;
  white-space: pre-line;

  @media (max-width: $containerWidth) {
    height: pxToVw(826px);
  }
  .text {
    margin: 0 10%;
  }
  .year {
    color: #fff153;
  }
}

.bgEnd {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 957px;
  z-index: 0;
  @media (max-width: $containerWidth) {
    height: pxToVw(957px);
  }
}
</style>
